// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"0":"codemirror","3":"react-movable","4":"react-sortable-hoc"}[chunkId] || chunkId) + ".min.js?" + {"0":"5c85d97d87545bb4197d","3":"3ebca955c321e3cf3920","4":"c3b79319e0435fb8502c","5":"78ecff39632ccdf912fe"}[chunkId] + "";
};